import { render, staticRenderFns } from "./ItsBaseTeam.vue?vue&type=template&id=5f2c7719&scoped=true&"
import script from "./ItsBaseTeam.vue?vue&type=script&lang=js&"
export * from "./ItsBaseTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c7719",
  null
  
)

export default component.exports